import { render, staticRenderFns } from "./Societe.vue?vue&type=template&id=2d2557b6&scoped=true&"
import script from "./Societe.vue?vue&type=script&lang=js&"
export * from "./Societe.vue?vue&type=script&lang=js&"
import style0 from "./Societe.vue?vue&type=style&index=0&id=2d2557b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2557b6",
  null
  
)

export default component.exports